import { useState } from "react";
import { DYNAMICS, TIMELINES, VALUES } from "../lib/api";
import { inputCls, resizeImage } from "../lib/ui";

const editInputCls = inputCls.replace("py-4", "py-3");

export const ProfileEditForm = ({ initial, onSave, onCancel, saving }) => {
  const [form, setForm] = useState(initial);

  const toggleValue = (v) =>
    setForm((f) => ({
      ...f,
      values: f.values.includes(v) ? f.values.filter((x) => x !== v) : [...f.values, v],
    }));

  return (
    <div className="space-y-6">
      <div className="flex gap-6">
        <input
          data-testid="profile-age-input"
          className={editInputCls}
          type="number"
          placeholder="Age"
          value={form.age}
          onChange={(e) => setForm({ ...form, age: e.target.value })}
        />
        <input
          data-testid="profile-location-input"
          className={editInputCls}
          placeholder="Location"
          value={form.location}
          onChange={(e) => setForm({ ...form, location: e.target.value })}
        />
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
          Relationship dynamic
        </label>
        <div className="mt-3 flex flex-wrap gap-2">
          {DYNAMICS.map((d) => (
            <button
              key={d.key}
              data-testid={`profile-dynamic-${d.key}`}
              onClick={() => setForm({ ...form, relationship_dynamic: d.key })}
              className={`px-4 py-2 border text-sm transition-colors duration-300 ${
                form.relationship_dynamic === d.key
                  ? "bg-[#7A3B3F] text-[#FAF9F6] border-[#7A3B3F]"
                  : "border-[#E5E0D8] text-[#5C5C5C] hover:border-[#7A3B3F]"
              }`}
            >
              {d.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
          Marriage timeline
        </label>
        <div className="mt-3 flex flex-wrap gap-2">
          {TIMELINES.map((t) => (
            <button
              key={t.key}
              data-testid={`profile-timeline-${t.key}`}
              onClick={() => setForm({ ...form, marriage_timeline: t.key })}
              className={`px-4 py-2 border text-sm transition-colors duration-300 ${
                form.marriage_timeline === t.key
                  ? "bg-[#4A5D4E] text-[#FAF9F6] border-[#4A5D4E]"
                  : "border-[#E5E0D8] text-[#5C5C5C] hover:border-[#4A5D4E]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
          Values
        </label>
        <div className="mt-3 flex flex-wrap gap-2">
          {VALUES.map((v) => (
            <button
              key={v}
              onClick={() => toggleValue(v)}
              className={`px-4 py-1.5 border text-sm capitalize transition-colors duration-300 ${
                form.values.includes(v)
                  ? "bg-[#4A5D4E] text-[#FAF9F6] border-[#4A5D4E]"
                  : "border-[#E5E0D8] text-[#5C5C5C]"
              }`}
            >
              {v}
            </button>
          ))}
        </div>
      </div>
      <textarea
        data-testid="profile-bio-input"
        className={`${editInputCls} min-h-[100px] resize-none`}
        placeholder="Your bio"
        value={form.bio}
        onChange={(e) => setForm({ ...form, bio: e.target.value })}
      />
      <div>
        <label className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
          Change photo
        </label>
        <input
          data-testid="profile-photo-input"
          type="file"
          accept="image/*"
          className="mt-3 block text-sm text-[#5C5C5C]"
          onChange={async (e) => {
            const f = e.target.files?.[0];
            if (f) setForm({ ...form, photo_url: await resizeImage(f) });
          }}
        />
      </div>
      <div className="flex gap-4 pt-4">
        <button
          data-testid="profile-save-button"
          onClick={() => onSave(form)}
          disabled={saving}
          className="bg-[#7A3B3F] text-[#FAF9F6] px-8 py-3 hover:bg-[#5D2B2E] transition-colors duration-300 disabled:opacity-50"
        >
          {saving ? "Saving…" : "Save changes"}
        </button>
        <button
          data-testid="profile-cancel-button"
          onClick={onCancel}
          className="text-[#5C5C5C] hover:text-[#1A1A1A] transition-colors duration-300"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
